module.exports = __webpack_public_path__ + "img/trophy.72729097.png";